import React from 'react';
import { Avatar } from '@mui/material';
import { useSelector } from 'react-redux';
import usericon from '../../assets/images/usericon.svg';

const AvatarUser = ({ logo, customStyles = {} }) => {
  const user = useSelector(({ auth }) => auth.user);
  // function stringToColor(string) {
  //   let hash = 0;
  //   let i;

  //   /* eslint-disable no-bitwise */
  //   for (i = 0; i < string?.length; i += 1) {
  //     hash = string.charCodeAt(i) + ((hash << 5) - hash);
  //   }

  //   let color = '#';

  //   for (i = 0; i < 3; i += 1) {
  //     const value = (hash >> (i * 8)) & 0xff;
  //     color += `00${value.toString(16)}`.slice(-2);
  //   }
  //   /* eslint-enable no-bitwise */

  //   return color;
  // }

  // function stringAvatar(name) {
  //   if (!name) {
  //     return;
  //   }
  //   return {
  //     sx: {
  //       bgcolor: stringToColor(name),
  //     },
  //     children: `${name?.split(' ')[0][0]}`,
  //   };
  // }

  if (logo) {
    return (
      <>
        <Avatar src={logo} alt="photoURL" sx={{ width: 36, height: 36 }} style={customStyles} />
      </>
    );
  }

  return (
    <>
      <Avatar
        className={!user?.avatar ? 'avatarAisle' : ''}
        src={user?.avatar ? user?.avatar : usericon}
        alt="photoURL"
        // {...stringAvatar(user.name)}
        sx={{ width: 36, height: 36 }}
        style={customStyles}
      />
    </>
  );
};

export default AvatarUser;
